<template lang="pug">
div(class="d-flex flex-row tw-relative tw-w-full  tw-text-white theme-f-footer-container tw-py-10 tw-mt-10")
  v-container(fluid class="tw-px-20")
    v-row(align="start" no-gutters justify="space-between")
      v-col(cols="3")
        div(class="tw-grid")
          div(class="tw-z-10 tw-row-span-full tw-col-span-12 tw-col-start-1 ")
            kubiqa-website-shared-widget-editor(
              page="home"
              placement="footer_left"
              @content="(content) => (content != null ? ((defaultFooterLeft = false), key++) : ((defaultFooterLeft = true), key++))"
            )
          div(v-if="defaultFooterLeft" :key="key" class="tw-z-0 tw-row-span-full tw-col-start-1 tw-col-span-12  tw-align-middle")
            v-row
              v-col
                span(class="tw-text-2xl") realtor
            v-row
              v-col(class="tw-text-blueGray-lighten-1 ")
                div(class="tw-pt-4")
                  span {{ this.$faker().address.streetAddress(true) }}
                div(class="tw-pt-2")
                  span {{ this.$faker().address.county() }}, {{ this.$faker().address.stateAbbr() }}
                div(class="tw-pt-2")
                  span {{ this.$faker().phone.phoneNumber() }}

      v-col(justify="center")
        div(class="tw-grid")
          div(class="tw-z-10 tw-row-span-full tw-col-span-12 tw-col-start-1 tw-content-center  ")
            kubiqa-website-shared-widget-editor(
              page="home"
              placement="footer_center"
              @content="(content) => (content != null ? ((defaultFooterCenter = false), key++) : ((defaultFooterCenter = true), key++))"
            )
          div(
            v-if="defaultFooterCenter"
            :key="key"
            class="tw-z-0 tw-row-span-full tw-col-start-1 tw-col-span-12  tw-align-middle"
          )
            v-row(justify="space-around")
              v-col(cols="auto")
                v-row
                  v-col
                    span(class=" tw-text-lg tw-font-medium") Properties
                v-row
                  v-col(class="tw-text-blueGray-lighten-1 tw-font-medium")
                    div(class="tw-py-1") Appartments
                    div(class="tw-py-1") Houses
                    div(class="tw-py-1") Commercial
                    div(class="tw-py-1") Plots
              v-col(cols="auto")
                v-row
                  v-col
                    span(class=" tw-text-lg tw-font-medium") Opportunities
                v-row
                  v-col(class="tw-text-blueGray-lighten-1 tw-font-medium")
                    div(class="tw-py-1") Rent
                    div(class="tw-py-1") Buy
                    div(class="tw-py-1") Sell

      v-col(cols="2" class=" tw-self-end tw-p-0 tw-m-0")
        div(class="tw-grid ")
          div(class="tw-z-10 tw-row-span-full tw-col-span-12 tw-col-start-1  ")
            kubiqa-website-shared-widget-editor(
              page="home"
              placement="footer_right"
              @content="(content) => (content != null ? ((defaultFooterRight = false), key++) : ((defaultFooterRight = true), key++))"
            )
          div(
            v-if="defaultFooterRight"
            :key="key"
            class="tw-z-0 tw-row-span-full tw-col-start-1 tw-col-span-12  tw-content-end tw-text-right"
          )
            v-icon(color="blue-grey lighten-1") mdi-facebook
            v-icon(color="blue-grey lighten-1" class="tw-mx-2") mdi-twitter
            v-icon(color="blue-grey lighten-1") mdi-whatsapp
</template>
<script>
export default {
  data() {
    return {
      key: 0,
      defaultFooterLeft: null,
      defaultFooterCenter: null,
      defaultFooterRight: null,
    };
  },
};
</script>
<style lang="scss">
.theme-f-footer-container {
  background-color: #16171d;
  border-top-left-radius: 70px;
  border-top-right-radius: 70px;
}
</style>
